import React from "react";
import classes from "./Section1.module.css";
import { Link } from "react-router-dom";

export default function Section1() {
  return (
    <section className={classes.section}>
      <div className={`container ${classes.container}`}>
        <div className={classes.intro}>
          <h2>Empowering Physicians with Smarter RCM Solutions</h2>
          <p>
            We start every engagement with a detailed revenue cycle analysis to
            identify gaps and improvement opportunities. Our team, including
            experienced{" "}
            <Link to="/services/denial-management/" style={{ color: "#fff" }}>
              denial management specialists
            </Link>
            , reviews each stage of the process such as credentialing, payer
            enrollment, and claim processing to ensure accuracy, compliance, and
            efficiency.
          </p>
        </div>

        <div className={classes.grid}>
          <div className={classes.sideLabel}>
            <span>PHYSICIANS</span>
          </div>

          <div className={classes.column}>
            <article
              className={`${classes.card} ${classes.light} ${classes.experience}`}
            >
              <h3>20 YEARS!</h3>
              <p>Industry Experience</p>
            </article>
            <div className={classes.partnerLabel}>SUCCESS PARTNERS</div>
          </div>

          <div className={classes.column}>
            <article
              className={`${classes.card} ${classes.blue} ${classes.rejection}`}
            >
              <h3>03%</h3>
              <p>AR Rejection Rate</p>
            </article>
            <article
              className={`${classes.card} ${classes.light} ${classes.accuracy}`}
            >
              <h3>98%</h3>
              <p>Accuracy Rate</p>
            </article>
          </div>

          <div className={classes.column}>
            <article
              className={`${classes.card} ${classes.blue} ${classes.hipaa}`}
            >
              <h3>100%</h3>
              <p>HIPAA Compliance</p>
            </article>
          </div>

          <div className={classes.column}>
            <article
              className={`${classes.card} ${classes.light} ${classes.assurance}`}
            >
              <p>Accurate Procedure &amp; Diagnosis Process</p>
            </article>
            <article
              className={`${classes.card} ${classes.blue} ${classes.timely}`}
            >
              <p>Timely Payments</p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
